/**
 * All known location data
 */
const _LOCATIONS = {
    "unknown": {
        "label": "Unknown",
        "continent": "Unknown",
        "uiIcon": "/assets/images/icons/spacer.png"
    },
    "dc_location-ams": {
        "label" : "Amsterdam, NL",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/netherlands.svg"
    },
    "dc_location-fra": {
        "label" : "Frankfurt, DE",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/germany.svg"
    },
    "dc_location-lhr": {
        "label": "London, UK",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/uk.svg"
    },
    "dc_location-dfw": {
        "label": "Dallas, TX",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "dc_location-sin": {
        "label": "Singapore, SG",
        "continent": "Asia",
        "uiIcon": "/assets/images/dc-locations/sin.svg"
    },
    "dc_location-lax": {
        "label": "Los Angeles, CA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "dc_location-iad": {
        "label": "Washington, D.C.",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "dc_location-mia": {
        "label": "Miami, FL",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-east-1": {
        "label": "North Virginia, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-east-2": {
        "label": "Ohio, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-west-1": {
        "label": "North California, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-west-2": {
        "label": "Oregon, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "ap-south-1": {
        "label": "Mumbai, India",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/india.svg"
    },
    "ap-south-2": {
        "label": "Hyderabad, India",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/india.svg"
    },
    "ap-northeast-1": {
        "label": "Tokyo, Japan",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/japan.svg"
    },
    "ap-northeast-2": {
        "label": "Seoul, South Korea",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/south-korea.svg"
    },
    "ap-northeast-3": {
        "label": "Osaka, Japan",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/japan.svg"
    },
    "ap-southeast-1": {
        "label": "Singapore, Asia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/singapore.svg"
    },
    "ap-southeast-2": {
        "label": "Sydney, Australia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/australia.svg"
    },
    "ca-central-1": {
        "label": "Canada (Central)",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/canada.svg"
    },
    "eu-central-1": {
        "label": "Frankfurt, Germany",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/germany.svg"
    },
    "eu-west-1": {
        "label": "Dublin, Ireland",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/ireland.svg"
    },
    "eu-west-2": {
        "label": "London, UK",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/uk.svg"
    },
    "eu-west-3": {
        "label": "Paris, France",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/france.svg"
    },
    "eu-north-1": {
        "label": "Stockholm, Sweden",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/sweden.svg"
    },
    "sa-east-1": {
        "label": "São Paulo, Brazil",
        "continent": "South America",
        "uiIcon": "/assets/images/dc-locations/brazil.svg"
    },
    "ap-east-1": {
        "label": "Hong Kong, Asia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/hong-kong.svg"
    },
    "af-south-1": {
        "label": "Cape Town, SA",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/south-africa.svg"
    },
    "ap-southeast-3": {
        "label": "Jakarta, Indonesia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/indonesia.svg"
    },
    "ap-southeast-4": {
        "label": "Melbourne, Australia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/australia.svg"
    },
    "eu-south-1": {
        "label": "Milan, Italy",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/italy.svg"
    },
    "eu-south-2": {
        "label": "Zaragoza, Spain",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/spain.svg"
    },
    "eu-central-2": {
        "label": "Zurich, Switzerland",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/switzerland.svg"
    },
    "me-south-1": {
        "label": "Bahrain",
        "continent": "Middle East",
        "uiIcon": "/assets/images/dc-locations/bahrain.svg"
    },
    "me-central-1": {
        "label": "UAE",
        "continent": "Middle East",
        "uiIcon": "/assets/images/dc-locations/uae.svg"
    },
    "asia-east1": {
        "label": "Changhua, Taiwan",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/taiwan.svg"
    },
    "asia-east2": {
        "label": "Hong Kong, Asia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/hong-kong.svg"
    },
    "asia-northeast1": {
        "label": "Tokyo, Japan",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/japan.svg"
    },
    "asia-northeast2": {
        "label": "Osaka, Japan",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/japan.svg"
    },
    "asia-northeast3": {
        "label": "Seoul, South Korea",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/south-korea.svg"
    },
    "asia-south1": {
        "label": "Mumbai, India",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/india.svg"
    },
    "asia-south2": {
        "label": "Delhi, India",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/india.svg"
    },
    "asia-southeast1": {
        "label": "Singapore, Asia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/singapore.svg"
    },
    "asia-southeast2": {
        "label": "Jakarta, Indonesia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/indonesia.svg"
    },
    "australia-southeast1": {
        "label": "Sydney, Australia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/australia.svg"
    },
    "australia-southeast2": {
        "label": "Melbourne, Australia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/australia.svg"
    },
    "europe-central2": {
        "label": "Warsaw, Poland",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/poland.svg"
    },
    "europe-north1": {
        "label": "Hamina, Finland",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/finland.svg"
    },
    "europe-southwest1": {
        "label": "Madrid, Spain",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/spain.svg"
    },
    "europe-west1": {
        "label": "St. Ghislain, Belgium",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/belgium.svg"
    },
    "europe-west12": {
        "label": "Turin, Italy",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/italy.svg"
    },
    "europe-west2": {
        "label": "London, England",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/uk.svg"
    },
    "europe-west3": {
        "label": "Frankfurt, Germany",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/germany.svg"
    },
    "europe-west4": {
        "label": "Eemshaven, Netherlands",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/netherlands.svg"
    },
    "europe-west6": {
        "label": "Zurich, Switzerland",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/switzerland.svg"
    },
    "europe-west8": {
        "label": "Milan, Italy",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/italy.svg"
    },
    "europe-west9": {
        "label": "Paris, France",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/france.svg"
    },
    "me-west1": {
        "label": "Tel Aviv, Israel",
        "continent": "Middle East",
        "uiIcon": "/assets/images/dc-locations/israel.svg"
    },
    "northamerica-northeast1": {
        "label": "Montréal, Québec",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/canada.svg"
    },
    "northamerica-northeast2": {
        "label": "Toronto, Ontario",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/canada.svg"
    },
    "southamerica-east1": {
        "label": "São Paulo, Brazil",
        "continent": "South America",
        "uiIcon": "/assets/images/dc-locations/brazil.svg"
    },
    "southamerica-west1": {
        "label": "Santiago, Chile",
        "continent": "South America",
        "uiIcon": "/assets/images/dc-locations/chile.svg"
    },
    "us-central1": {
        "label": "Iowa, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-east1": {
        "label": "South Carolina, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-east4": {
        "label": "Virginia, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-east5": {
        "label": "Ohio, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-south1": {
        "label": "Texas, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-west1": {
        "label": "Oregon, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-west2": {
        "label": "California, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-west3": {
        "label": "Utah, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-west4": {
        "label": "Nevada, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    }
}

/**
 * All background light
 */
const _BACKGROUNDSLIGHT = {
    "Amsterdam, NL": "url(/assets/images/cities/amsterdam-light.webp)",
    "Los Angeles, CA": "url(/assets/images/cities/la-light.webp)",
    "Washington, D.C.": "url(/assets/images/cities/washington-light.webp)",
    "Miami, FL": "url(/assets/images/cities/miami-light.webp)",
    "Bahrain": "url(/assets/images/cities/bahrain-light.webp)",
    "California, USA": "url(/assets/images/cities/california-light.webp)",
    "Canada (Central)": "url(/assets/images/cities/toronto-light.webp)",
    "Cape Town, SA": "url(/assets/images/cities/cape-town-light.webp)",
    "Changhua, Taiwan": "url(/assets/images/cities/taiwan-light.webp)",
    "Dallas, TX": "url(/assets/images/cities/dallas-light.webp)",
    "Delhi, India": "url(/assets/images/cities/delhi-light.webp)",
    "Dublin, Ireland": "url(/assets/images/cities/dublin-light.webp)",
    "Eemshaven, Netherlands": "url(/assets/images/cities/eemshaven-light.webp)",
    "Frankfurt, DE": "url(/assets/images/cities/frankfurt-light.webp)",
    "Frankfurt, Germany": "url(/assets/images/cities/frankfurt-light.webp)",
    "Hamina, Finland": "url(/assets/images/cities/hamina-light.webp)",
    "Hong Kong, Asia": "url(/assets/images/cities/hong-kong-light.webp)",
    "Hyderabad, India": "url(/assets/images/cities/hyderabad-light.webp)",
    "Iowa, USA": "url(/assets/images/cities/iowa-light.webp)",
    "Jakarta, Indonesia": "url(/assets/images/cities/jakarta-light.webp)",
    "London, England": "url(/assets/images/cities/london-light.webp)",
    "London, UK": "url(/assets/images/cities/london-light.webp)",
    "Madrid, Spain": "url(/assets/images/cities/madrid-light.webp)",
    "Melbourne, Australia": "url(/assets/images/cities/melbourne-light.webp)",
    "Milan, Italy": "url(/assets/images/cities/milan-light.webp)",
    "Montréal, Québec": "url(/assets/images/cities/montreal-light.webp)",
    "Mumbai, India": "url(/assets/images/cities/mumbai-light.webp)",
    "Nevada, USA": "url(/assets/images/cities/nevada-light.webp)",
    "North California, USA": "url(/assets/images/cities/northern-california-light.webp)",
    "North Virginia, USA": "url(/assets/images/cities/virginia-light.webp)",
    "Ohio, USA": "url(/assets/images/cities/ohio-light.webp)",
    "Oregon, USA": "url(/assets/images/cities/oregon-light.webp)",
    "Osaka, Japan": "url(/assets/images/cities/osaka-light.webp)",
    "Paris, France": "url(/assets/images/cities/paris-light.webp)",
    "Santiago, Chile": "url(/assets/images/cities/santiago-light.webp)",
    "São Paulo, Brazil": "url(/assets/images/cities/sao-paulo-light.webp)",
    "Seoul, South Korea": "url(/assets/images/cities/seoul-light.webp)",
    "Singapore, Asia": "url(/assets/images/cities/singapore-light.webp)",
    "Singapore, SG": "url(/assets/images/cities/singapore-light.webp)",
    "South Carolina, USA": "url(/assets/images/cities/south-carolina-light.webp)",
    "St. Ghislain, Belgium": "url(/assets/images/cities/saint-ghislain-light.webp)",
    "Stockholm, Sweden": "url(/assets/images/cities/stockholm-light.webp)",
    "Sydney, Australia": "url(/assets/images/cities/sydney-light.webp)",
    "Tel Aviv, Israel": "url(/assets/images/cities/tel-aviv-light.webp)",
    "Texas, USA": "url(/assets/images/cities/texas-light.webp)",
    "Tokyo, Japan": "url(/assets/images/cities/tokyo-light.webp)",
    "Toronto, Ontario": "url(/assets/images/cities/toronto-light.webp)",
    "Turin, Italy": "url(/assets/images/cities/turin-light.webp)",
    "UAE": "url(/assets/images/cities/united-arab-emirates-light.webp)",
    "Utah, USA": "url(/assets/images/cities/utah-light.webp)",
    "Virginia, USA": "url(/assets/images/cities/virginia-light.webp)",
    "Warsaw, Poland": "url(/assets/images/cities/warsaw-light.webp)",
    "Zaragoza, Spain": "url(/assets/images/cities/zaragoza-light.webp)",
    "Zurich, Switzerland": "url(/assets/images/cities/zurich-light.webp)",
}

/**
 * All background Dark
 */
const _BACKGROUNDSDARK = {
    "Amsterdam, NL": "url(/assets/images/cities/amsterdam-dark.webp)",
    "Los Angeles, CA": "url(/assets/images/cities/la-dark.webp)",
    "Miami, FL": "url(/assets/images/cities/miami-dark.webp)",
    "Washington, D.C.": "url(/assets/images/cities/washington-dark.webp)",
    "Bahrain": "url(/assets/images/cities/bahrain-dark.webp)",
    "California, USA": "url(/assets/images/cities/california-dark.webp)",
    "Canada (Central)": "url(/assets/images/cities/toronto-dark.webp)",
    "Cape Town, SA": "url(/assets/images/cities/cape-town-dark.webp)",
    "Changhua, Taiwan": "url(/assets/images/cities/taiwan-dark.webp)",
    "Dallas, TX": "url(/assets/images/cities/dallas-dark.webp)",
    "Delhi, India": "url(/assets/images/cities/delhi-dark.webp)",
    "Dublin, Ireland": "url(/assets/images/cities/dublin-dark.webp)",
    "Eemshaven, Netherlands": "url(/assets/images/cities/eemshaven-dark.webp)",
    "Frankfurt, DE": "url(/assets/images/cities/frankfurt-dark.webp)",
    "Frankfurt, Germany": "url(/assets/images/cities/frankfurt-dark.webp)",
    "Hamina, Finland": "url(/assets/images/cities/hamina-dark.webp)",
    "Hong Kong, Asia": "url(/assets/images/cities/hong-kong-dark.webp)",
    "Hyderabad, India": "url(/assets/images/cities/hyderabad-dark.webp)",
    "Iowa, USA": "url(/assets/images/cities/iowa-dark.webp)",
    "Jakarta, Indonesia": "url(/assets/images/cities/jakarta-dark.webp)",
    "London, England": "url(/assets/images/cities/london-dark.webp)",
    "London, UK": "url(/assets/images/cities/london-dark.webp)",
    "Madrid, Spain": "url(/assets/images/cities/madrid-dark.webp)",
    "Melbourne, Australia": "url(/assets/images/cities/melbourne-dark.webp)",
    "Milan, Italy": "url(/assets/images/cities/milan-dark.webp)",
    "Montréal, Québec": "url(/assets/images/cities/montreal-dark.webp)",
    "Mumbai, India": "url(/assets/images/cities/mumbai-dark.webp)",
    "Nevada, USA": "url(/assets/images/cities/nevada-dark.webp)",
    "North California, USA": "url(/assets/images/cities/northern-california-dark.webp)",
    "North Virginia, USA": "url(/assets/images/cities/virginia-dark.webp)",
    "Ohio, USA": "url(/assets/images/cities/ohio-dark.webp)",
    "Oregon, USA": "url(/assets/images/cities/oregon-dark.webp)",
    "Osaka, Japan": "url(/assets/images/cities/osaka-dark.webp)",
    "Paris, France": "url(/assets/images/cities/paris-dark.webp)",
    "Santiago, Chile": "url(/assets/images/cities/santiago-dark.webp)",
    "São Paulo, Brazil": "url(/assets/images/cities/sao-paulo-dark.webp)",
    "Seoul, South Korea": "url(/assets/images/cities/seoul-dark.webp)",
    "Singapore, Asia": "url(/assets/images/cities/singapore-dark.webp)",
    "Singapore, SG": "url(/assets/images/cities/singapore-dark.webp)",
    "South Carolina, USA": "url(/assets/images/cities/south-carolina-dark.webp)",
    "St. Ghislain, Belgium": "url(/assets/images/cities/saint-ghislain-dark.webp)",
    "Stockholm, Sweden": "url(/assets/images/cities/stockholm-dark.webp)",
    "Sydney, Australia": "url(/assets/images/cities/sydney-dark.webp)",
    "Tel Aviv, Israel": "url(/assets/images/cities/tel-aviv-dark.webp)",
    "Texas, USA": "url(/assets/images/cities/texas-dark.webp)",
    "Tokyo, Japan": "url(/assets/images/cities/tokyo-dark.webp)",
    "Toronto, Ontario": "url(/assets/images/cities/toronto-dark.webp)",
    "Turin, Italy": "url(/assets/images/cities/turin-dark.webp)",
    "UAE": "url(/assets/images/cities/united-arab-emirates-dark.webp)",
    "Utah, USA": "url(/assets/images/cities/utah-dark.webp)",
    "Virginia, USA": "url(/assets/images/cities/virginia-dark.webp)",
    "Warsaw, Poland": "url(/assets/images/cities/warsaw-dark.webp)",
    "Zaragoza, Spain": "url(/assets/images/cities/zaragoza-dark.webp)",
    "Zurich, Switzerland": "url(/assets/images/cities/zurich-dark.webp)",
}

/**
 * Utility class to handle server dcLocations
 */
class ServerLocationUtils {
    /**
     * Returns the icon for a given location code
     *
     * @param {string} locationCode - the location code for which the icon is required
     * @returns {string} the icon for the location code
     */
    static uiIcon(locationCode) {
        let location = locationCode

        if (typeof _LOCATIONS[location] == 'undefined') {
            location = 'unknown'
        }

        return _LOCATIONS[location].uiIcon
    }

    /**
     * Returns the user-friendly label for a given location code
     *
     * @param {string} locationCode - the location code for which the label is required
     * @returns {string} the user-friendly label for the location code
     */
    static uiFriendlyLabel(locationCode) {
        let location = locationCode

        if (typeof _LOCATIONS[location] == 'undefined') {
            location = 'unknown'
        }

        return _LOCATIONS[location].label
    }
    /**
    * Returns a trimmed version of the user-friendly label for a given location code
    *
    * @param {string} locationCode - the location code for which the label is required
    * @returns {string} the user-friendly label for the location code
    */
    static shortUiFriendlyLabel(locationCode) {
        const str = this.uiFriendlyLabel(locationCode)
        const commaIdx = str.indexOf(',');
        const parenIdx = str.indexOf('(');
        const words = str.trim().split(/\s+/);
        const secondWordIdx = words.length >= 2
            ? str.indexOf(words[1], str.indexOf(words[0]) + words[0].length) + words[1].length
            : str.length;

        const cutPoints = [commaIdx, parenIdx, secondWordIdx]
            .filter(i => i !== -1); // Remove not-found (-1)

        const trimIdx = Math.min(...cutPoints);

        return str.substring(0, trimIdx).trim();

    }
    /**
     * Returns the continent string for a given location code
     *
     * @param {string} locationCode - the location code for which the continent string is required
     * @returns {string} the continent string for the location code
     */
    static uiFriendlyContinentLabel(locationCode) {
        let location = locationCode

        if (typeof _LOCATIONS[location] == 'undefined') {
            location = 'unknown'
        }

        return _LOCATIONS[location].continent
    }
}
